<template>
    <div class="dorm_properties">
        <div class="row">
            <div class="col-md-12">
                <button class="btn btn-success pull-right" @click="goCreate"><i class="fa fa-plus"></i> Yeni Özellik Ekle</button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Özellik</th>
                                        <th>Kategori</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in items" :key="item.id">
                                        <td>{{ item.title }}</td>
                                        <td>{{ item.category.title }}</td>
                                        <td>
                                            <router-link :to="{ name: 'dorm_properties.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs" @click="destroy(item)">Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                tableName: 'Yurt Özellikleri',
                icon: 'fa fa-cog',
                tableDesc: '',
                api: 'dorm_properties/',
                items: [],
                university: '',
                universities: [],
                search: '',
                pagination: {
                    'current_page': 1
                }
            }
        },
        mounted () {
            this.getData()
        },
        methods: {
            getData() {
                this.$Progress.start()
                this.axios.get(this.api + 'list').then(response => {
                    this.items = response.data
                    this.$Progress.finish()
                })
            },
            destroy(item) {
                this.$swal({
                    title: 'Silmek istediğinizden emin misiniz?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Evet',
                    cancelButtonText: 'İptal'
                    }).then((result) => {
                        if(result.value) {
                            this.axios.delete(this.api + item.id).then(response => {
                                if (response.status == 200) {
                                    this.$swal(
                                        'Başarılı!',
                                        'Veri silme işlemi başarılı',
                                        'success'
                                    )
                                    this.items.splice(this.items.indexOf(item), 1)
                                }
                            })
                        }
                    })
            },
            goCreate() {
                this.$router.push({ name: 'dorm_properties.create' })
            }
        },
    }
</script>

<style scoped>

</style>